var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Inspection Address"}}),_c('LocationForm',{ref:"location",attrs:{"model":_vm.locationComponentData},on:{"submit":_vm.submitForm,"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }